export default {"src":"/_next/static/image/public/images/ic_credit_card_blue_vertical_menu.cd6bcb51726cc97dc8d1f5c57288184b.svg","height":20,"width":20};